import { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import clone from 'clone-deep'
import { nav } from 'tiny-react-router'
import { ToastContainer, toast } from 'react-toastify'
import {
  AiOutlineDelete,
  AiOutlineCloseSquare
} from 'react-icons/ai'
import { 
  format_date,
  format_phone_number,
  getNextEventDate
} from '../../shared/utils'
import { 
  useOrderStore,
  useConfigStore,
  useAccountStore,
  useProductStore,
  useSubscriptionStore 
} from '../../shared/state'
import CampaignSection from '../../shared/components/CampaignSection'
import OrderWizard from '../../shared/components/OrderWizard'
import SubscriptionWizard from '../../shared/components/SubscriptionWizard'
import OrderDetails from '../../shared/components/OrderDetails'
import UtsolgtImg from '../../shared/graphics/utsolgt.png'
import 'react-toastify/dist/ReactToastify.css'
import './toast-mods.css'

export default function Main() {
  const orders = useOrderStore(s => s.orders)
  const account = useAccountStore(s => s.account)
  const products = useProductStore(s => s.products)
  const toastRef = useRef(null)
  //const setOrders = useOrderStore(s => s.setOrders)
  const setAccount = useAccountStore(s => s.setAccount)
  const fetchOrders = useOrderStore(s => s.fetchOrders)
  const transportFee = useConfigStore(s => s.transportFee)
  const hasMoreOrders = useOrderStore(s => s.hasMore)
  const subscriptions = useSubscriptionStore(s => s.subscriptions)
  const setSubscriptions = useSubscriptionStore(s => s.setSubscriptions)
  const postalCodesNoFee = useConfigStore(s => s.postalCodesNoFee)
  const subscriptionDiscount = useConfigStore(s => s.subscriptionDiscount)
  const [tab, setTab] = useState('orders')
  const [adding_sub, set_adding_sub] = useState(false)
  const [adding_order, set_adding_order] = useState(false)
  const [numOrdersToFetch, setNumOrdersToFetch] = useState(10)
  const [selected_products, set_selected_products] = useState([])
  const [selected_details_order, set_selected_details_order] = useState(null)
  const [selected_details_subscription, set_selected_details_subscription] = useState(null)
  const [reorder_prefill, set_reorder_prefill] = useState(null)

  let add_transport_fee = true
  try {
    const postal_code = account?.data?.address?.postal_code
    if (postal_code) add_transport_fee = postalCodesNoFee.indexOf(parseInt(postal_code)) < 0
  } catch(e) {}

  useEffect(() => {
    const fullUrl = window.location.href;
    const queryString = fullUrl.includes('?') ? fullUrl.split('?')[1] : '';
    const urlParams = new URLSearchParams(queryString);
    const vippsresult = urlParams.get('vippsresult')
    setTimeout(() => {
      if (vippsresult === 'Betalt' && !toast.isActive(toastRef.current)) 
        toastRef.current = toast('Bestilling mottat. Vi vil levere din bestilling så snart vi kan. Du kan følge status på denne siden.', { autoClose: 10000 })
      if (vippsresult === 'Problem' && !toast.isActive(toastRef.current)) 
        toastRef.current = toast.error('Det oppstod et problem med din vipps betaling. Kontakt support hvis problemet fortsetter.', { autoClose: 10000 })
      if (vippsresult === 'nosublink' && !toast.isActive(toastRef.current)) 
        toastRef.current = toast('Abonnements-lenken er allerede brukt.', { autoClose: 10000 })
      }, Math.random()*500)
    const campaignresult= urlParams.get('campaignresult')
    setTimeout(() => {
      if (campaignresult === 'no_more_slots' && !toast.isActive(toastRef.current)) 
        toastRef.current = toast('Det var desverre ingen flere plasser igjen på kampanjen. Bedre lykke neste gang 😬', { autoClose: 10000 })
      if (campaignresult === 'no_such_campaign' && !toast.isActive(toastRef.current)) 
        toastRef.current = toast('Ukjent kampanje 🤔', { autoClose: 10000 })
      }, Math.random()*500)
    async function fetchOrdersNow() {
      await fetchOrders(numOrdersToFetch)
    }
    fetchOrdersNow()
    const fetchOrdersInterval = setInterval(async () => {
      await fetchOrders(numOrdersToFetch)
    }, 3000)
    return () => clearInterval(fetchOrdersInterval)
  }, [fetchOrders, numOrdersToFetch])

  const handleLogout = async () => {
    const logout_res = await fetch(`/api/logout`)
    if (logout_res.status !== 200) return
    setAccount(null)
    nav('/')
  }

  const handleSelectProduct = (product_id) => {
    let prod = products.find(p => p.id === product_id) 
    if (prod?.data?.sold_out) return
    let p = clone(prod)
    p.grind = 'bønner'
    set_selected_products(selected_products.concat(p))
  }

  const handleUpdateAccountConfig = async (key, value, include) => {
    let current_contact = (account?.config?.contact || [])
    let current_subscription_contact = (account?.config?.subscription_contact || [])
    if (key === 'contact') {
      if (include) current_contact.push(value)
      else current_contact = current_contact.filter(c => c !== value)
      current_contact = [...new Set(current_contact)]
    }
    if (key === 'subscription_contact') {
      current_subscription_contact = [value]
    }
    const updated_account = await fetch(`/api/me`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        contact: current_contact,
        subscription_contact: current_subscription_contact
      })
    })
    if (!updated_account.ok) return toast.error('Kunne ikke oppdatere preferanser')
    const _account = await updated_account.json()
    setAccount(_account)
  }

  const handleAddingSub = () => {
    set_adding_sub(!adding_sub)
  }

  const handleSubscriptionComplete = (data) => {
    set_adding_sub(false)
    setSubscriptions(data)
    let channel = 'melding'
    try { 
      channel = account.config.subscription_contact[0] 
      if (channel === 'sms') channel = 'SMS'
      if (channel === 'email') channel = 'epost'
    } catch(e) {}
    toast(`Abonnement opprettet. Du vil straks motta en ${channel} med lenke til første ordre.`, { autoClose: 10000 })
  }

  const handleRemoveSubscription = async (sid) => {
    const sub_res = await fetch(`/api/subscriptions`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: sid
      })
    })
    if (sub_res.status !== 200) return toast.error('Kunne ikke slette abonnement')
    const subs = await sub_res.json()
    setSubscriptions(subs)
    toast('Abonnement slettet')
  }

  const handleReorder = (order) => {
    set_reorder_prefill(order)
    set_adding_order(true)
  }

  const handleDeleteSelectedProduct = (i) => {
    let sel_prods = [
      ...selected_products.slice(0, i), 
      ...selected_products.slice(i+ 1)
    ];
    set_selected_products(sel_prods)
  }

  const handleSetSelectedProductGrind = (i, grind) => {
    const sel_prods = selected_products.map((p,_i) => {
      if (_i === i) p.grind = grind
      return p
    })
    set_selected_products(sel_prods)
  }

  const handleCreateNewOrder = async () => {
    const payload = {
      products: selected_products,
      transport_fee: add_transport_fee ? transportFee : 0
    }
    const order_res = await fetch(`/api/orders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    if (order_res.status !== 200) return toast.error('Kunne ikke opprette bestillingen') 
    const order_json = await order_res.json()
    window.location.href = order_json.redirectUrl
//    set_selected_products([])
//    set_adding_order(false)
//    setOrders(orders)
//    toast('Ordre mottat. Du vil straks motta en Vipps forespørsel for denne ordren.', { autoClose: 10000 })
  }

  const subRows = subscriptions.map(s => {
    const prods = (s?.data?.products || []).map(p => {
      return products.filter(_p => _p?.id === p?.id)[0]
    })
    if (prods.indexOf(undefined) >= 0) return null // Product not found
    // TODO: Old abbos need to DISPLAY the new name & logo... Admin page.. Here already works?
    // TODO: Indicate discount! price = Math.floor(price * 0.9) use config.subscriptionDiscount
    const price = prods.reduce((sum, p) => sum += p?.data?.price, 0) + (s?.data?.transport_fee || 0)
    const discounted_price = Math.floor(price * subscriptionDiscount)
    const prodItems = prods.map((p,i) => (
      <ProductItem key={`${p.id}${i}`} onClick={() => set_selected_details_subscription(s)}>
        <img src={p?.data?.bag} alt={p?.data?.name || 'Kaffepose'} />
      </ProductItem>
    ))
    let next_order_date = 'Ukjent'
    try {
      next_order_date = getNextEventDate(new Date(s?.data?.last_order_date), s?.data?.interval)
    } catch(e) {}
    return (
      <SubscriptionRow key={s.id}>
        <SubscriptionRowProducts>{prodItems}</SubscriptionRowProducts>
        <SubscriptionRowInterval>{s?.data?.interval}</SubscriptionRowInterval>
        <SubscriptionRowDates>{format_date(new Date(s?.created_at))}</SubscriptionRowDates>
        <SubscriptionRowInterval>{format_date(next_order_date, { failed: 'Ikke bestemt' })}</SubscriptionRowInterval>
        <SubscriptionRowInterval>{`NOK ${discounted_price},-`}</SubscriptionRowInterval>
        <SubscriptionRowRemove><AiOutlineDelete onClick={() => handleRemoveSubscription(s.id)} size="1.3em" /></SubscriptionRowRemove>
      </SubscriptionRow>
    )
  })
  
  // Using the shared OrderDetails component for orders and subscriptions
  const orderDetails = selected_details_order ? (
    <OrderDetails 
      order={selected_details_order} 
      onClose={() => set_selected_details_order(null)} 
    />
  ) : null
  
  const subscriptionDetails = selected_details_subscription ? (
    <OrderDetails 
      order={selected_details_subscription} 
      onClose={() => set_selected_details_subscription(null)} 
      isSubscription={true} 
    />
  ) : null

  const orderRows = orders
    .filter(s => s?.data?.status !== 'Slettet')
    .map(s => {
      const prods = (s?.data?.products || []).map(p => {
        p.orig = products.find(op => op.id === p.id)
        return p
      })
      let price = prods.reduce((sum, p) => sum += p?.data?.price, 0)+ (s?.data?.transport_fee || 0)
      if (s?.data?.price_paid) price = s?.data?.price_paid
      if (s?.data?.subscription_price_paid) price = s?.data?.subscription_price_paid
      const prodItems = prods.map((p,i) => (
        <ProductItem key={`${p.id}${i}`} onClick={() => set_selected_details_order(s)}>
          <img src={p?.orig?.data?.bag} alt={p?.orig?.data?.name || 'Kaffepose'} />
        </ProductItem>
      ))
      return (
        <SubscriptionRow key={s.id}>
          <SubscriptionRowProducts>{prodItems}</SubscriptionRowProducts>
          <OrderRowDetails>
            <SubscriptionRowInterval>{format_date(new Date(s?.created_at))}</SubscriptionRowInterval>
            <SubscriptionRowInterval>{`NOK ${price},-`}</SubscriptionRowInterval>
            <SubscriptionRowInterval>{s?.data?.status}</SubscriptionRowInterval>
          </OrderRowDetails>
          <ReorderButton onClick={(e) => { e.stopPropagation(); handleReorder(s) }}>
            Bestill igjen
          </ReorderButton>
        </SubscriptionRow>
      )
    })

  const productList = products
    .filter(p => p?.data?.bag)
    .filter(p => p?.data?.show !== false)
    .sort((a,b) => {
      if (a?.data?.order > b?.data.order) return 1
      if (a?.data?.order < b?.data.order) return -1
      return 0
    })
    .map(p => {
      const selected = selected_products.map(p => p.id).indexOf(p.id) >= 0
      return (
        <ProductItem key={p.id} selected={selected} onClick={() => handleSelectProduct(p.id)} soldout={`${p?.data?.sold_out}`}>
          <img className="productImage" src={p?.data?.bag} alt={p?.data?.name || 'Kaffepose'} />
          { p?.data?.sold_out &&
            <UtsolgtImage src={UtsolgtImg} alt="Utsolgt" />
          }
        </ProductItem>
      )
    })

  let selected_products_price = 0
  const selected_products_text = selected_products.map((sp,i) => {
    const product = products.find(p => p.id === sp.id)
    selected_products_price = selected_products_price += product?.data?.price
    return (
      <SelectedProduct key={product.id+i}>
        <SelectedProductName>{product?.data?.name}</SelectedProductName>
        <SelectedProductCost>{`${product?.data?.price},-`}</SelectedProductCost>
        <SelectedProductGrind>
          <select value={sp?.grind} onChange={(e) => handleSetSelectedProductGrind(i, e.target.value)}>
            <option value="bønner">Bønner</option>
            <option value="filtermalt">Filtermalt</option>
            <option value="kokmalt">Kokmalt</option>
            <option value="finmalt">Finmalt</option>
          </select>
        </SelectedProductGrind>
        <SelectedProductDelete onClick={() => handleDeleteSelectedProduct(i)}><AiOutlineDelete /></SelectedProductDelete>
      </SelectedProduct>
    )
  })
  if (add_transport_fee) {
    selected_products_text.push((
        <SelectedProduct key="transport">
          <SelectedProductName>Frakt</SelectedProductName>
          <SelectedProductCost>{`${transportFee},-`}</SelectedProductCost>
          <div style={{ flex: 'auto' }}></div>
        </SelectedProduct>
    ))
    selected_products_price += transportFee
  }
  if (adding_sub) {
    let discounted_price = Math.floor(selected_products_price * subscriptionDiscount)
    let discount = selected_products_price - discounted_price
    selected_products_text.push((
        <SelectedProduct key="discount">
          <SelectedProductName>Rabatt</SelectedProductName>
          <SelectedProductCost>{`- ${discount},-`}</SelectedProductCost>
          <div style={{ flex: 'auto' }}></div>
        </SelectedProduct>
    ))
    selected_products_price = discounted_price
  }

  return (
    <Container modal={selected_details_order || selected_details_subscription}>
      <AccountSection>
        <SectionHeadingRow>
          <SectionHeading>Konto</SectionHeading>
          <AccountButtons>
            <button className="purple" onClick={handleLogout}>Logg ut</button>
          </AccountButtons>
        </SectionHeadingRow>
        <AccountInfo>
          <AccountInfoSection>
            <AccountElement>
              <label>Navn</label>
              <div>{account?.data?.name}</div>
            </AccountElement>
            <AccountElement>
              <label>Adresse</label>
              <div>{account?.data?.address?.street_address}</div>
            </AccountElement>
          </AccountInfoSection>
          <AccountInfoSection>
            <AccountElement>
              <label>Telefon</label>
              <div>{format_phone_number(account?.data?.phone_number)}</div>
            </AccountElement>
            <AccountElement>
              <label>Epost</label>
              <div>{account?.data?.email}</div>
            </AccountElement>
          </AccountInfoSection>
        </AccountInfo>
        <AccountSettings>
          <h3>Preferanser</h3>
          <AccountInfo>
            <AccountElement>
              <label>Kontakt</label>
              <p>Bøllefrø kan kontakte meg med tilbud, nye produkter, etc.</p>
              <div>
                <label><input type="checkbox" checked={(account?.config?.contact || []).indexOf('email') >= 0} onChange={(e) => handleUpdateAccountConfig('contact', 'email', e.target.checked)} />Epost</label>
                <label><input type="checkbox" checked={(account?.config?.contact || []).indexOf('sms') >= 0} onChange={(e) => handleUpdateAccountConfig('contact', 'sms', e.target.checked)} />SMS</label>
              </div>
            </AccountElement>
            <AccountElement>
              <label>Abonnement</label>
              <p>Jeg ønsker å motta lenker for betaling av abonnement på:</p>
              <div>
                <label><input type="radio" checked={(account?.config?.subscription_contact || []).indexOf('email') >= 0} onChange={(e) => handleUpdateAccountConfig('subscription_contact', 'email', e.target.checked)} />Epost</label>
                <label><input type="radio" checked={(account?.config?.subscription_contact || []).indexOf('sms') >= 0} onChange={(e) => handleUpdateAccountConfig('subscription_contact', 'sms', e.target.checked)} />SMS</label>
              </div>
            </AccountElement>
          </AccountInfo>
        </AccountSettings>
        <AccountInfo>
          { add_transport_fee &&
            <AccountTransportInfo>Du bor i et område uten gratis levering og vi legger til <b>NOK {transportFee},- for frakt</b> på alle dine ordre.</AccountTransportInfo>
          }
          { !add_transport_fee &&
            <AccountTransportInfo><b>Du bor i et område med gratis levering!</b><br/>Vi legger derfor ikke til frakt på dine ordre.</AccountTransportInfo>
          }
        </AccountInfo>
      </AccountSection>
      <CampaignSection />
      
      <TabsContainer>
        <Tab selected={tab === 'orders'} onClick={() => setTab('orders')}>Bestillinger</Tab>
        <Tab selected={tab === 'subscriptions'} onClick={() => setTab('subscriptions')}>Abonnement</Tab>
      </TabsContainer>
      
      { tab === 'subscriptions' && 
        <SubscriptionSection>
          <SectionHeadingRow>
            <SectionHeading>Abonnement</SectionHeading>
            <button className="purple" onClick={handleAddingSub}>Legg til</button>
          </SectionHeadingRow>
          <p>
            Abonnement er løpende ordre på kaffe.<br/>
            Vi oppretter automatisk ordre for deg for det intervallet og de produktene du har valgt.<br/>
            Du vil motta en sms eller epost (velg over) for hver ordre. Meldingen inneholder en lenke som åpner en Vipps forespørsel.<br/>
            Dersom du ikke trenger leveranse den aktuelle perioden, er det bare å ikke klikke på lenken.<br />
            Enkelt!
          </p>
          { adding_sub &&
            <SubscriptionWizard 
              onCancel={() => set_adding_sub(false)}
              onComplete={handleSubscriptionComplete}
            />
          }
          {subRows}
        </SubscriptionSection>
      }
      
      { tab === 'orders' &&
        <OrderSection>
          <SectionHeadingRow>
            <SectionHeading>Bestillinger</SectionHeading>
            <button className="purple" onClick={() => set_adding_order(!adding_order)}>Legg til</button>
          </SectionHeadingRow>
          <p>
            Her kan du bestille kaffe.<br />
            Dine tidligere bestillinger listes under (også abonnements-bestillinger).<br/>
            Du mottar en Vipps forespørsel for hver bestilling.<br />
            Enkelt!
          </p>
          { adding_order &&
            <OrderWizard
              onCancel={() => { set_adding_order(false); set_reorder_prefill(null) }}
              onComplete={() => {
                set_adding_order(false)
                set_selected_products([])
                set_reorder_prefill(null)
              }}
              prefillOrder={reorder_prefill}
            />
          }
          {orderRows}
          { hasMoreOrders &&
            <HasMoreOrdersContainer>
              <button className="purple" onClick={() => setNumOrdersToFetch(numOrdersToFetch+10)}>Hent flere bestillinger...</button>
            </HasMoreOrdersContainer>
          }
        </OrderSection>
      }
      {orderDetails}
      {subscriptionDetails}
      <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${props => props.modal ? `
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5); 
    z-index: 1; 
  };
  ` : ''}
`

const SectionHeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const SectionHeading = styled.h1`
  margin: 0;
  padding: 20px 0px;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
`

const AccountSection = styled(Section)`
  color: white;
  background-color: var(--color-vipps);
  padding: 20px;
  padding-bottom: 30px;
`

const SubscriptionSection = styled(Section)`
  background-color: var(--color-splash-yellow);
  padding: 20px;

  & p {
    font-size: 1em;
    line-height: 1.5em;
  }
`

const OrderSection = styled(Section)`
  background-color: var(--color-splash-yellow);
  padding: 20px;

  & p {
    font-size: 1em;
    line-height: 1.5em;
  }
`

const AccountInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const AccountSettings = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const AccountInfoSection = styled.div`
  @media (max-width: 768px) {
    font-size: 0.8em;
  }
`

const AccountElement = styled.div`
  margin: 10px;
  & label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  & p {
    font-size: 0.9em;
    max-width: 150px;
  }
`

const AccountButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ProductItem = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  & .productImage {
    width: ${props => `${props?.size || 80}px`};
    @media (max-width: 768px) {
      width: ${props => `${props?.size || 57}px`};
    }
    border: 1px solid black;
    ${props => props.soldout === 'true' ? 'filter: grayscale(100%);' : ''}
  }
`

const SubscriptionRow = styled.div`
  padding: 20px 0px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dotted black;
  font-family: monospace;
  &:last-child {
    border-bottom: 0;
    padding-bottom: 20px;
  }
  @media (max-width: 768px) {
    font-size: 0.8em;
  }
`

const SubscriptionRowProducts = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 200px;
  gap: 10px;
  & img {
    width: 40px;
  }
  @media (max-width: 768px) {
    width: 100px;
    & img {
      width: 30px;
    }
  }
`

const OrderRowDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2px;
    text-align: center;
  }
`

const SubscriptionRowInterval = styled.div`
  text-transform: capitalize;
  min-width: 100px;
  @media (max-width: 768px) {
    min-width: auto;
  }
`

const SubscriptionRowDates = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

const SubscriptionRowRemove = styled.div`
  cursor: pointer;
`

const ReorderButton = styled.button`
  background-color: var(--color-splash-purple);
  color: white;
  border: none;
  padding: 5px 10px;
  font-size: 0.8em;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    opacity: 0.85;
  }
`

const SelectedProduct = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 2px;
  width: 100%;
  gap: 15px;
 
  & input {
    width: 30px;
  }
`

const SelectedProductName = styled.div`
  width: 100px;
`
const SelectedProductCost = styled.div`
  width: 50px;
  text-align: right;
`
const SelectedProductGrind = styled.div``
const SelectedProductDelete = styled.div`
  cursor: pointer;
`

const AccountTransportInfo = styled.div`
  padding: 10px;
  max-width: 35%; 
  text-align: center;
  font-style: italic;
  @media (max-width: 768px) {
    max-width: 70%; 
  }
`

const UtsolgtImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  border: 0px!important;
`

const HasMoreOrdersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`

const TabsContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-left: 20px;
  background-color: var(--color-splash-purple);
`

const Tab = styled.div`
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  font-weight: bold;
  color: white;
  ${props => props?.selected ? 'background-color: var(--color-splash-yellow); color: black;' : ''}
  cursor: pointer;
`